
import Vue from 'vue'
import states from '@/helpers/states'
import { QRadio } from 'quasar'
export default Vue.extend({
    components: { QRadio },
    props: {
        stateKey: {
            type: String
        },
        selected: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        state() {
            return states[(<any>this).stateKey]
        }
    }
})
